var map = {
	"./Google-SignIn.svg": 36103,
	"./addconsignee.svg": 33455,
	"./arrow-up.1.svg": 88089,
	"./arrow-up.svg": 60274,
	"./checkboxtick.1.svg": 28358,
	"./checkboxtick.svg": 69993,
	"./column-picker.svg": 64654,
	"./containers.svg": 4329,
	"./dashboard_empty_state_icon.svg": 22337,
	"./destination.1.svg": 65552,
	"./destination.svg": 48207,
	"./dot.1.svg": 12869,
	"./dot.svg": 90230,
	"./dropdown_arrow.svg": 36248,
	"./fill_arrow.1.svg": 27083,
	"./fill_arrow.svg": 26384,
	"./fill_arrow_white.1.svg": 73697,
	"./fill_arrow_white.svg": 26346,
	"./filtericon.svg": 29076,
	"./generic_logo.svg": 61966,
	"./halt.svg": 30220,
	"./hover-shape.1.svg": 926,
	"./hover-shape.svg": 19601,
	"./icon-column.1.svg": 52942,
	"./icon-column.svg": 66273,
	"./icon-no-lanes-bg.svg": 96672,
	"./icon-search.svg": 50751,
	"./icon-sort-arrow.svg": 80763,
	"./icon-sort.svg": 52143,
	"./invalid-material.svg": 47884,
	"./invoicetriangle.1.svg": 80305,
	"./invoicetriangle.svg": 954,
	"./loading_split.1.svg": 37685,
	"./loading_split.svg": 23110,
	"./logo.1.svg": 31771,
	"./logo.svg": 39200,
	"./maricologo.svg": 94491,
	"./mdm.svg": 28635,
	"./menu.svg": 95856,
	"./minus.1.svg": 84528,
	"./minus.svg": 75983,
	"./ms-symbollockup_signin_dark.svg": 63076,
	"./noindents.1.svg": 93486,
	"./noindents.svg": 37089,
	"./optima-settings.svg": 63615,
	"./optima.svg": 27199,
	"./orders.svg": 15458,
	"./payment.svg": 34681,
	"./paymentemptystage.1.svg": 9769,
	"./paymentemptystage.svg": 21698,
	"./plus.svg": 897,
	"./setting.svg": 10703,
	"./source.svg": 6198,
	"./transporterlogo.svg": 82284,
	"./truck-small.svg": 87244,
	"./truck.svg": 82406,
	"./valid-invalid.svg": 88723,
	"./valid-material.svg": 34133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90052;